module.exports = __webpack_public_path__ + "img/collect_pic_3.4fade8d6.png";